import React, {Component} from "react";
import FilterToolbar from "../../../ui/filters/FilterToolbar";

// Style file.
import '../../../../assets/sass/pages/matches-and-events/results.scss';
import MatchesResults from "./results/MatchesResults";
import UpcomingMatchesFilters from "./filters/UpcomingMatchesFilters";

class Results extends Component {
    state = {
        search: null,
        regions: [],
        countries: [],
        competitions: [],
        teams: [],
        venues: [],
    };

    render = () => {
        return (
            <div className="results">
                {this.renderFilters()}
                {this.renderMatches()}
            </div>
        );
    };

    renderFilters = () => {
        return (
            <UpcomingMatchesFilters onChange={this.handleFiltersChange}/>
        );
    };

    renderMatches = () => {
        const {regions, countries, competitions, teams, venues, search} = this.state;

        return (
            <MatchesResults search={search} regions={regions} countries={countries} competitions={competitions} teams={teams} venues={venues}/>
        );
    };

    handleFiltersChange = options => this.setState({
        regions: options?.regions?.map(item => item.value),
        countries: options?.countries?.map(item => item.value),
        competitions: options?.competitions?.map(item => item.value),
        teams: options?.teams?.map(item => item.value),
        venues: options?.venues?.map(item => item.value),
        search: options?.search,
    });

}


export default Results;
